	/*
	 * Enable click event for the Brochures filter buttons
	 */
	exports.setupBrochuresFilterWidget = function (WidgetuuID, DefaultFilterBy) {
		var lstMainSelectors = ['#campus_' + WidgetuuID],
			lstOtherSelectors = ['#category_' + WidgetuuID];

		var $campusFilter = $('#campus_' + WidgetuuID);
		var $categoryFilter = $('#category_' + WidgetuuID);

		// Activate Click event under the filter buttons
		$('#Btncategory_' + WidgetuuID).click(function () {
			FusionDivBoutonsGroup(this);
			ShowHideElements(lstMainSelectors,lstOtherSelectors, true);
			refreshBrochuresFilterWidget(WidgetuuID, ($campusFilter.val() > 0)? 'CampusID=' + $campusFilter.val() : null);
		});

		$('#Btncampus_' + WidgetuuID).click(function () {
			FusionDivBoutonsGroup(this);
			ShowHideElements(lstMainSelectors,lstOtherSelectors, false);
			refreshBrochuresFilterWidget(WidgetuuID, ($categoryFilter.val() > 0)? 'categoryID=' + $categoryFilter.val() : null);
		});
		$('#campus_' + WidgetuuID).change(function () {
			refreshBrochuresFilterWidget(WidgetuuID,((this.value.length > 0) ? 'CampusID=' + this.value : ''));
		});
		$('#category_' + WidgetuuID).change(function () {
			refreshBrochuresFilterWidget(WidgetuuID, ((this.value.length > 0) ? 'categoryID=' + this.value : ''));
		});

		$('#submit_brochure_form_' + WidgetuuID).click(function () {
			if ($('#selected-brochures').val().length > 0) {
				$('#frmBrochure_' + WidgetuuID).submit();
			} else {
				$('#frmBrochure_' + WidgetuuID + ' .brochures-valid-selection').removeClass('hide');
				return false;
			}
		});

		ShowHideElements(lstMainSelectors,lstOtherSelectors, (DefaultFilterBy == 'category'));

		window.lcb.module.brochurefilter.enableSaveBrochureSelectionEvent();
	};

	/*
	 * Refresh the Brochures listing when we change the filters (Campus or category)
	 */
	function refreshBrochuresFilterWidget(WidgetuuID, filter) {
		var mode = $('#Btncategory_' + WidgetuuID).hasClass('selected') ? "category" : "Campus";
		var subItemContainer = $('#Btncategory_' + WidgetuuID).hasClass('selected') ? "campuses" : "categories";
		var DataWidgetUUID = WidgetuuID;

		var url =  (mode == "category") ?  window.lcb.config.apiPaths.BrochuresCategories : window.lcb.config.apiPaths.BrochuresCampuses;
		var language = $("meta[name='language-id']").attr('content');

		LoadApiData(url, 'LangID=' + language + '&' + filter, { onSuccess: function (data) {
			data.subItemContainer = subItemContainer;
			data.WidgetuuID = DataWidgetUUID;
		  	LoadUnderscoreTemplate(window.lcb.config.templatePaths.brochuresForm,data, {
																						onSuccess: function(html){
																							LoadTemplateDiv('#divBrochuresContainer_'+WidgetuuID,html, {
																								pagination: false
																							});
																							$(".accordion").foundation();
																							window.lcb.module.brochurefilter.enableSaveBrochureSelectionEvent();
																						}
																					  });
		}});
	}
	exports.enableSaveBrochureSelectionEvent = function(){
		$('.brochures-form').find('.lcb-brochure-option').off( 'click');
		$('.brochures-form').find('.lcb-brochure-option').click(function(){
			LoadApiData('/index.cfm?fa=BrochureMod.SaveBrochureSelection', {
				action: (($(this).prop('checked') != '') ? 'add' : 'remove'),
				campusID: $(this).data('campusid'),
				literaturesID: $(this).data('literatureid'),
				LangID: $(this).data('langid'),
				HardCopy: $(this).data('hardcopy')
			}, {
				onSuccess: function(data){
					//set a flag to know if we have at least 1 literature selected somewhere in the session. Can not be accurate...From specs...
					$('#selected-brochures').val(($.isEmptyObject(data.campuses) ? "": "true"));
					$('#selected-brochures').data('jsonselection', data);
				}
			});
		});
	};

	exports.getBrochureProgramsTems = function(iLangID) {
		Program = $('#iProgram').val();
		Term = $('#iTerm').val();
		HearAbout = $('#HearAboutID').val();

		LoadLinkedComponentValues('iCampusID', 'iProgram','BrochureMod.GetProgramsForCampusID_JSON', {param:'&iLangID='+iLangID,ShowFirstRow:1,keepDisabled:0}, Program);
		LoadLinkedComponentValues('iCampusID', 'iTerm','BrochureMod.GetTermsForCampusID_JSON', {param:'&iLangID='+iLangID,ShowFirstRow:1,keepDisabled:0}, Term);
		LoadLinkedComponentValues('iCampusID', 'HearAboutID','BrochureMod.GetHearAboutUsForCampusID_JSON', {param:'&iLangID='+iLangID,ShowFirstRow:1,keepDisabled:0}, HearAbout);

		$("#iYear").attr("disabled",  $("#iCampusID").val()==0 ? true : false);
	}

	exports.changeHearAboutUs = function(parentCssClass = '.form-row')
	{
		iSubcategoryID = jQuery("#HearAboutID").val();
		if (iSubcategoryID>0){
			jQuery.get("/index.cfm?fa=CampaignModAct.actGetSubCategoryHasFreeText&iSubCategoryID="+iSubcategoryID, function(data){
				if (data == 1){
					jQuery("#cReferredText").parent(parentCssClass).removeClass('hide');
				} else {
					jQuery("#cReferredText").parent(parentCssClass).addClass('hide')
					jQuery("#cReferredText").val("");
				}
			});
		} else {
			jQuery("#cReferredText").parent(parentCssClass).addClass('hide')
			jQuery("#cReferredText").val("");
		}
	}